import React from 'react'
import $t from '../../../i18n'
import { Spin } from 'antd'

import './CardListView.css'
import EmptyList from '../EmptyList'
import CardListItem from '../CardListItem'

const CardListView = ({
  data,
  isLoading,
  dataName,
  category,
  emptyTitle,
  imageName
}) => {
  return (
    <div className='card-list-view'>
      {isLoading && <Spin size='large' />}
      {!isLoading &&
        (data && !!data?.length ? (
          data?.map(
            (
              {
                id,
                issueDate,
                title,
                subtitle,
                doctor,
                dateRange,
                comment,
                onClick,
                isPressable,
                antidote_clinic,
                isFollowUp,
                isSeen,
                patientId,
                actions,
                status
              },
              i
            ) => (
              <CardListItem
                key={id || patientId + i}
                patientId={patientId}
                issueDate={issueDate}
                title={title}
                subtitle={subtitle}
                imageName={imageName}
                onCardClick={onClick}
                isLoading={isLoading}
                dataName={dataName}
                status={status}
                index={i}
              />
            )
          )
        ) : (
          <EmptyList title={emptyTitle || $t('alerts.noItems', { category })} />
        ))}
    </div>
  )
}

export default CardListView
